import { create } from "zustand";
import { usePersistentFetch } from "../utils/usePersistentFetch";
import { api } from "api";

const useStore = create((set) => ({
  applicationYears: [],
  latestActiveYear: undefined,
  isFetched: false,
  setApplicationYears: (data) => {
    set({
      applicationYears: data.applicationYears,
      latestActiveYear: data.latestActiveYear,
      isFetched: true,
    });
  },
}));

const useOpekepeApplicationYears = () => {
  const setApplicationYears = useStore((state) => state.setApplicationYears);
  const applicationYears = useStore((state) => state.applicationYears);
  const latestActiveYear = useStore((state) => state.latestActiveYear);
  const isFetched = useStore((state) => state.isFetched);

  const { fetchState } = usePersistentFetch({
    isFetched,
    setStoreData: setApplicationYears,
    fetchFn: api.opekepe.fetchApplicationYears,
    queryKey: "applicationYears",
  });

  return { applicationYears, latestActiveYear, fetchState };
};

export { useOpekepeApplicationYears };
